<script setup lang="ts">
const props = defineProps<{
	hasPadding?: boolean;
}>();
</script>

<template>
	<span class="dropdown-divider" :class="{ 'dropdown-divider--has-padding': props.hasPadding }"></span>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.dropdown-divider
	{
		display:block;
		border-block-end:1px solid var(--border-primary);

		&--has-padding
		{
			padding-block-end:var(--spacing-4xs);
			margin-block-end:var(--spacing-4xs);
		}
	}
}
</style>
